import {FacilityEvaluationSections2} from "./FacilityEvaluationSections2";
import {AppAspectDefinition} from "../../javascript.lib.mojo-base/model/app.aspect/AppAspectDefinition";


export class FacilityEvaluationSections3 {

  static readonly evaluationSections: AppAspectDefinition[] = FacilityEvaluationSections2.evaluationSections;

}
